
interface PollsLoadingStateProps {
  countryName?: string;
}

const PollsLoadingState = ({ countryName }: PollsLoadingStateProps) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-2xl font-bold text-nation-blue mb-6">Polls for {countryName}</h2>
      <div className="text-center py-8">Loading polls...</div>
    </div>
  );
};

export default PollsLoadingState;
